import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tw-min-h-[calc(100vh-60px)] tw-bg-gradient-to-br tw-from-slate-50 tw-via-white tw-to-indigo-50 tw-py-6" }
const _hoisted_2 = { class: "tw-mx-auto tw-w-full tw-max-w-6xl tw-px-4 sm:tw-px-6 lg:tw-px-8" }
const _hoisted_3 = { class: "tw-rounded-2xl tw-border tw-border-slate-200/70 tw-bg-white/60 tw-backdrop-blur tw-shadow-sm tw-shadow-slate-200/50" }
const _hoisted_4 = { class: "tw-px-4 tw-py-4 sm:tw-px-6" }
const _hoisted_5 = { class: "tw-flex tw-flex-wrap tw-gap-2" }
const _hoisted_6 = { class: "tw-border-t tw-border-slate-200/70" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProfileAccountTab = _resolveComponent("ProfileAccountTab")!
  const _component_TerminalLogins = _resolveComponent("TerminalLogins")!
  const _component_ProfileDriversTab = _resolveComponent("ProfileDriversTab")!
  const _component_ProfileTrucksTab = _resolveComponent("ProfileTrucksTab")!
  const _component_ProfileVesselsTab = _resolveComponent("ProfileVesselsTab")!
  const _component_TrackingSettingsTab = _resolveComponent("TrackingSettingsTab")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "tw-mb-5 tw-text-left" }, [
        _createElementVNode("h2", { class: "tw-text-2xl tw-font-semibold tw-text-slate-900" }, "Settings"),
        _createElementVNode("div", { class: "tw-mt-1 tw-text-sm tw-text-slate-600" }, "Manage terminals, drivers, trucks, and factoring preferences.")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["tw-rounded-full tw-border tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-transition", _ctx.activeTab === 'account'
                ? 'tw-border-transparent tw-bg-slate-900 tw-text-white'
                : 'tw-border-slate-200/70 tw-bg-white/70 tw-text-slate-700 hover:tw-bg-white']),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.activeTab = 'account'))
            }, " Account ", 2),
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["tw-rounded-full tw-border tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-transition", _ctx.activeTab === 'terminal'
                ? 'tw-border-transparent tw-bg-slate-900 tw-text-white'
                : 'tw-border-slate-200/70 tw-bg-white/70 tw-text-slate-700 hover:tw-bg-white']),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeTab = 'terminal'))
            }, " Terminal Logins ", 2),
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["tw-rounded-full tw-border tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-transition", _ctx.activeTab === 'drivers'
                ? 'tw-border-transparent tw-bg-slate-900 tw-text-white'
                : 'tw-border-slate-200/70 tw-bg-white/70 tw-text-slate-700 hover:tw-bg-white']),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.activeTab = 'drivers'))
            }, " Drivers ", 2),
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["tw-rounded-full tw-border tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-transition", _ctx.activeTab === 'trucks'
                ? 'tw-border-transparent tw-bg-slate-900 tw-text-white'
                : 'tw-border-slate-200/70 tw-bg-white/70 tw-text-slate-700 hover:tw-bg-white']),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.activeTab = 'trucks'))
            }, " Trucks ", 2),
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["tw-rounded-full tw-border tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-transition", _ctx.activeTab === 'vessels'
                ? 'tw-border-transparent tw-bg-slate-900 tw-text-white'
                : 'tw-border-slate-200/70 tw-bg-white/70 tw-text-slate-700 hover:tw-bg-white']),
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.activeTab = 'vessels'))
            }, " Vessels ", 2),
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["tw-rounded-full tw-border tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-transition", _ctx.activeTab === 'tracking'
                ? 'tw-border-transparent tw-bg-slate-900 tw-text-white'
                : 'tw-border-slate-200/70 tw-bg-white/70 tw-text-slate-700 hover:tw-bg-white']),
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.activeTab = 'tracking'))
            }, " Tracking ", 2),
            _cache[6] || (_cache[6] = _createElementVNode("button", {
              type: "button",
              class: "tw-rounded-full tw-border tw-border-slate-200/70 tw-bg-white/70 tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-text-slate-500 tw-opacity-60 tw-cursor-not-allowed",
              disabled: ""
            }, " Factoring Company ", -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _withDirectives(_createElementVNode("div", null, [
            _createVNode(_component_ProfileAccountTab)
          ], 512), [
            [_vShow, _ctx.activeTab === 'account']
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _createVNode(_component_TerminalLogins)
          ], 512), [
            [_vShow, _ctx.activeTab === 'terminal']
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _createVNode(_component_ProfileDriversTab)
          ], 512), [
            [_vShow, _ctx.activeTab === 'drivers']
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _createVNode(_component_ProfileTrucksTab)
          ], 512), [
            [_vShow, _ctx.activeTab === 'trucks']
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _createVNode(_component_ProfileVesselsTab)
          ], 512), [
            [_vShow, _ctx.activeTab === 'vessels']
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _createVNode(_component_TrackingSettingsTab)
          ], 512), [
            [_vShow, _ctx.activeTab === 'tracking']
          ])
        ])
      ])
    ])
  ]))
}